import { memo, useCallback } from "react";
import type { GridRowIdGetter } from "@mui/x-data-grid";
import { FilterVariant } from "consts/filters";
import { TableGridMode } from "consts/table";
import { Filters as WaMessagingFilters, MenuItem } from "consts/waMessaging";
import { useWaMessagesActions } from "features/waMessaging/actions";
import {
    selectIsWaMessagingResourceLoading,
    selectIsWaMessagingResourceUninitialized,
    selectWaMessagingResourceSlice
} from "features/waMessaging/selectors";
import type { WaMessage } from "features/waMessaging/types";
import Resource from "ui/layouts/Resource";
import Table from "ui/widgets/Table";

const MessageLogs = () => {
    const { getWaMessages, downloadCsv } = useWaMessagesActions();

    const getRowId: GridRowIdGetter<WaMessage> = useCallback(
        ({ coreId }: WaMessage) => coreId as string,
        []
    );

    return (
        <Resource
            breadcrumbsProps={{
                heading: 'Message Logs',
                links: [{ name: '' }],
                sx: { mb: 0 }
            }}
        >
            <Table
                mode={TableGridMode.WaMessages}
                selectIsTableUninitialized={selectIsWaMessagingResourceUninitialized(MenuItem.WaMessages)}
                selectIsTableLoading={selectIsWaMessagingResourceLoading(MenuItem.WaMessages)}
                selectTableDataSlice={selectWaMessagingResourceSlice(MenuItem.WaMessages)}
                fetchTableData={getWaMessages}
                downloadCsv={downloadCsv}
                filterTypes={new Map<FilterVariant, string[]>([
                    [FilterVariant.Text, [
                        WaMessagingFilters.phone,
                        WaMessagingFilters.merchantId,
                        WaMessagingFilters.merchantName,
                        WaMessagingFilters.status
                    ]]
                ])}
                getRowId={getRowId}
                LayoutProps={{ sx: { m: '24px 0px' } }}
                FiltersProps={{ sx: { m: 0 } }}
            />
        </Resource>
    );
};

export default memo(MessageLogs);
